export const DAYS_OF_WEEK = [
  { dayOfWeek: 1, label: 'Sunday', short: 'Sun' },
  { dayOfWeek: 2, label: 'Monday', short: 'Mon' },
  { dayOfWeek: 3, label: 'Tuesday', short: 'Tue' },
  { dayOfWeek: 4, label: 'Wednesday', short: 'Wed' },
  { dayOfWeek: 5, label: 'Thursday', short: 'Thu' },
  { dayOfWeek: 6, label: 'Friday', short: 'Fri' },
  { dayOfWeek: 7, label: 'Saturday', short: 'Sat' },
]
